// extracted by mini-css-extract-plugin
export var infoRow = "_og-2";
export var labelContainer = "_og-0";
export var rightInfo = "_og-1";